<template>
    <FetchingBox ref="FetchingBoxRef" />
    <WXLast :lastWXData="lastWXData"/>
    <ChartLine v-if="tempData.length" id='tempChart' :label="t('Temperature [°C]')" data0Color="#fbd604" :data="tempData" :fill="false" :showLine1="true" :label2="t('Temperature Year Ago [°C]')" data2Color="#c0c0c0" :data2="tempYearData" :showLine2="true" :hideToolTip2="true" />
    <ChartLine v-if="pressData.length" id='presChart' :label="t('Pressure [hpa]')" data0Color="#fbd604" :data="pressData" :fill="true" :showLine1="true"/>
    <ChartLine v-if="humiData.length" id='humiChart' :label="t('Humidity [%]')" data0Color="#fbd604" :data="humiData" :fill="false" :showLine1="true"/>
    <ChartLine v-if="rainData.length" id='rainChart' :label="t('Rain [mm]')" data0Color="#fbd604" :data="rainData" :fill="true" :min="0" :showLine1="true"/>
    <ChartLine v-if="windData.length" id='windChart' :label="t('Wind Speed [km/h]')" data0Color="#fbd604" :data="windData" :showLine1="true" :label2="t('Wind Gust [km/h]')" data2Color="#b00000" :data2="windGData" :fill="false" :min="0" :showLine2="false"/>
    <ChartLine v-if="rainData.length" id='windDChart' :label="t('Wind Direction [°]')" data0Color="#fbd604" :data="windDData" :fill="false" :min="0" :max="360" :showLine1="false" />
</template>

<!-- ######################################################################################################## -->

<script setup>
import { ref, defineExpose } from 'vue'
import { getRawPackets, getWxTempBar, getClearData } from './../js/fetchdata.js'
import FetchingBox from './FetchingBox.vue'
import WXLast from "./WXLast.vue"
import ChartLine from "./ChartLine.vue"
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineExpose({
    removeFetchingWXDataTimer,
    fetchingWXDataTimer,
    clearWXData,
});

const data = ref(getClearData())
const lastWXData = ref(null)
const FetchingBoxRef = ref()
const timerEnabled = ref(false)
const interval = ref()
const tempData = ref([])
const pressData = ref([])
const humiData = ref([])
const rainData = ref([])
const windData = ref([])
const windGData = ref([])
const windDData = ref([])
const tempYearData = ref([])

function clearWXData() {
    data.value = getClearData
    lastWXData.value = null
    tempData.value = []
    pressData.value = []
    humiData.value = []
    rainData.value = []
    windData.value = []
    windGData.value = []
    windDData.value = []
    tempYearData.value = []
}

function removeFetchingWXDataTimer() {
    clearInterval(interval.value)    
}

async function fetchingWXDataTimer(call, date) {
    await fetchingWXData(call, date)
    interval.value = setInterval(() => {
        timerEnabled.value = true
        fetchingWXData(call, date)
    }, 60*1000);
}

async function fetchingWXData(call,date) {
    // console.log('fetchingData: ',call,date)
    let fetchingData = getClearData()
    // lastWXData.value = null
    if (call && date) {
        FetchingBoxRef.value.visible = true
        fetchingData = await getRawPackets(call,date,'1')
        // console.log('fetchingWXData-fetchingData: ',fetchingData)
        tempYearData.value = await getWxTempBar(call,date,'1')
        // console.log('fetchingWXData-fetchingWxTempBarData: ',tempYearData.value)
    }
    data.value = fetchingData.array
    if (fetchingData.array.length) {
        
        //=== dane dla Temp Chart
        tempData.value = []
        pressData.value = []
        humiData.value = []
        rainData.value = []
        windData.value = []
        windGData.value = []
        windDData.value = []

        for (let i = 0; i < fetchingData.array.length; i++) {
            if (fetchingData.array[i].wx) {
                if (fetchingData.array[i].wx.temp && fetchingData.array[i].receivedTime) {
                    tempData.value.push({x: fetchingData.array[i].receivedTime, y: fetchingData.array[i].wx.temp})
                    }

                if (fetchingData.array[i].wx.pressure && fetchingData.array[i].receivedTime) {
                    pressData.value.push({x: fetchingData.array[i].receivedTime, y: fetchingData.array[i].wx.pressure})
                    }

                if (fetchingData.array[i].wx.humidity && fetchingData.array[i].receivedTime) {
                    humiData.value.push({x: fetchingData.array[i].receivedTime, y: fetchingData.array[i].wx.humidity})
                    }

                if (fetchingData.array[i].wx.rain_1h && fetchingData.array[i].receivedTime) {
                    rainData.value.push({x: fetchingData.array[i].receivedTime, y: fetchingData.array[i].wx.rain_1h})
                    }

                if (fetchingData.array[i].wx.wind_speed && fetchingData.array[i].receivedTime) {
                    windData.value.push({x: fetchingData.array[i].receivedTime, y: fetchingData.array[i].wx.wind_speed})
                    }

                if (fetchingData.array[i].wx.wind_gust && fetchingData.array[i].receivedTime) {
                    windGData.value.push({x: fetchingData.array[i].receivedTime, y: fetchingData.array[i].wx.wind_gust})
                    }

                if (fetchingData.array[i].wx.wind_direction && fetchingData.array[i].receivedTime) {
                    windDData.value.push({x: fetchingData.array[i].receivedTime, y: fetchingData.array[i].wx.wind_direction})
                    }    
    
            }
        }

        // console.log('tempData: ',tempData.value)

        //=== dane dla WXLast
        for (let i = 0; i < fetchingData.array.length; i++) {
            if (fetchingData.array[i].wx) {
                lastWXData.value = fetchingData.array[i]
                break;
            }

        }
    }
    // console.log('fetchingWXData: ',data.value)
    // console.log('fetchingWXData: ',lastWXData.value)
    FetchingBoxRef.value.visible = false
}

</script>

<i18n>
    {
      "pl": {
        "Temperature [°C]": "Temperatura [°C]",
        "Temperature Year Ago [°C]": "Temperatura Rok Temu [°C]",
        "Pressure [hpa]": "Ciśnienie [hpa]",
        "Humidity [%]": "Wilgotność [%]",
        "Rain [mm]": "Opad [mm]",
        "Wind Speed [km/h]": "Wiatr Prędkość [km/h]",
        "Wind Gust [km/h]": "Wiatr Porywy [km/h]",
        "Wind Direction [°]": "Wiatr Kierunek [°]",
      }
    }
</i18n>
